import { render, staticRenderFns } from "./QualificationInfo.vue?vue&type=template&id=1fa07f9f&"
import script from "./QualificationInfo.vue?vue&type=script&lang=js&"
export * from "./QualificationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports